export default __webpack_public_path__ + "static/media/bus_137.91671d01.jpg";